import { useState, useRef } from "react";
import { FileText, Upload, X, Loader2 } from "lucide-react";
import { toast } from "sonner";
import { api, formatApiError } from "@/lib/api";

export default function BrochureUploader({ value = "", onChange }) {
  const [busy, setBusy] = useState(false);
  const inputRef = useRef(null);

  const handleFile = async (files) => {
    const f = files?.[0];
    if (!f) return;
    setBusy(true);
    try {
      const fd = new FormData();
      fd.append("file", f);
      const { data } = await api.post("/admin/upload-brochure", fd, { headers: { "Content-Type": "multipart/form-data" } });
      onChange(data.url);
      toast.success("Brochure uploaded");
    } catch (e) {
      toast.error(formatApiError(e.response?.data?.detail) || "Upload failed");
    } finally {
      setBusy(false);
      if (inputRef.current) inputRef.current.value = "";
    }
  };

  return (
    <div data-testid="brochure-uploader">
      <span className="text-[0.65rem] uppercase tracking-[0.14em] text-ptf-text/60">Brochure (PDF, shown as a download on the journey page)</span>
      <div className="mt-1 flex items-center gap-3">
        {value ? (
          <>
            <a href={value.startsWith("http") ? value : `${process.env.REACT_APP_BACKEND_URL}${value}`} target="_blank" rel="noopener noreferrer" data-testid="brochure-link" className="inline-flex items-center gap-2 border border-ptf-primary/20 px-4 py-2.5 text-xs text-ptf-primary hover:bg-ptf-primary/5 transition-colors">
              <FileText className="h-4 w-4 text-ptf-secondary" /> View uploaded brochure
            </a>
            <button type="button" onClick={() => onChange("")} data-testid="brochure-remove" className="grid h-9 w-9 place-items-center border border-ptf-primary/15 hover:bg-red-50">
              <X className="h-4 w-4 text-red-600" />
            </button>
          </>
        ) : (
          <button type="button" onClick={() => inputRef.current?.click()} disabled={busy} data-testid="brochure-upload-btn" className="inline-flex items-center gap-2 border border-dashed border-ptf-primary/30 px-4 py-2.5 text-xs uppercase tracking-[0.12em] text-ptf-secondary hover:bg-ptf-primary/5 transition-colors disabled:opacity-50">
            {busy ? <Loader2 className="h-4 w-4 animate-spin" /> : <Upload className="h-4 w-4" />}
            Upload PDF
          </button>
        )}
      </div>
      <input ref={inputRef} type="file" accept="application/pdf" className="hidden" onChange={(e) => handleFile(e.target.files)} />
    </div>
  );
}
